module.exports = __webpack_public_path__ + "img/video.5915d8f3.svg";